import React from 'react';

import { isNil } from 'ramda';

import { useTheme } from '@mui/material/styles';
import { GridCheckIcon, GridRenderCellParams } from '@mui/x-data-grid-pro';

const BooleanCell: React.FC<Pick<GridRenderCellParams<boolean>, 'value'>> = (
  props
) => {
  const theme = useTheme();
  /**
   * Show nothing if the value is false
   */
  if (isNil(props.value) || !props.value) {
    return <></>;
  }

  return (
    <GridCheckIcon
      style={{
        color: theme.palette.success.light
      }}
    />
  );
};

export default BooleanCell;
